module.exports = __webpack_public_path__ + "img/랜서.37fc7e85.png";